import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { IoIosMenu, IoMdContact } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { LuLogOut } from "react-icons/lu";
import { MdOutlinePassword } from "react-icons/md";
import { IoKeyOutline } from "react-icons/io5";

const Top = ({ currentUser }) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleInteraction = (event) => {
            if (
                showMenu &&
                menuRef.current &&
                !menuRef.current.contains(event.target)
            ) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleInteraction);
        document.addEventListener("touchstart", handleInteraction);
        document.addEventListener("touchmove", handleInteraction);
        document.addEventListener("wheel", handleInteraction);

        return () => {
            document.removeEventListener("mousedown", handleInteraction);
            document.removeEventListener("touchstart", handleInteraction);
            document.removeEventListener("touchmove", handleInteraction);
            document.removeEventListener("wheel", handleInteraction);
        };
    }, [showMenu]);



    const handleLogout = async () => {
        try {
            await axios.get(
                `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/api/v1/user/logout`,
                { withCredentials: true }
            );
            sessionStorage.removeItem("sessionActive");
            window.location.replace("/login");
        } catch (error) {
            toast.error("Failed to logout");
        }
    };

    const handleMenu = () => {
        setShowMenu((prev) => !prev);
    };

    const handleHome = () => {
        navigate("/");
    };

    return (
        <div className="flex justify-between items-center relative pb-1 border-b border-[#86203B] sm:mx-2 xl:mx-0 xl:px-3 mb-2 xl:mb-4 2xl:mb-5 xxl:mb-6  ">
            {/* <h2
                onClick={handleHome}
                className=" font-bold text-[16px] leading-none tracking-[0%] text-[#86203B]  pb-2 xl:pb-3 2xl:pb-4 xxl:pb-5 pl-2   xl:text-[20px] 2xl:text-[22px] xxl:text-[24px] cursor-pointer"
            >
                Powersolv PowerHires
            </h2> */}
            <img onClick={handleHome} src="/images/Powersolv.png" alt="" className="w-18 xl:w-28 2xl:w-34 xxl:w-40 absolute left-1 xl:left-3 cursor-pointer" />
            <h1 className="xl:text-[24px] 2xl:text-[26px] xxl:text-[28px] font-bold text-[#9a3257] mx-auto">PowerHires</h1>
            <div className=" z-[99] absolute right-1 xl:right-3">
                <button type="button" aria-label="Account menu" onClick={handleMenu}>
                    <IoIosMenu
                        color="#4D4D4D"
                        className="select-none w-[20px] h-[20px] sm:w-[24px] sm:h-[24px] xl:w-[28px] 2xl:w-[32px] xxl:h-[41px]  xl:h-[28px] 2xl:h-[32px] xxl:w-[41px] cursor-pointer "
                    />
                </button>
                {showMenu ? (
                    <div ref={menuRef} className="bg-white absolute right-0 top-5 xl:top-8 shadow-md rounded-[6px] overflow-hidden ">
                        <div className="gap-2 bg-[#87213C] text-white px-4 py-2 flex">
                            <div>
                                <IoMdContact size={"2em"} />
                            </div>
                            <div className="">
                                <p className="text-[14px] mb-[4px] leading-[14px]">{currentUser.name}</p>
                                <p className="text-[13px] leading-[14px]">{currentUser.email === import.meta.env.VITE_REACT_APP_FIRST_ADMIN ? "Super Admin" : currentUser.role.slice(0, 1).toUpperCase() + currentUser.role.slice(1)}</p>
                            </div>
                        </div>
                        <div className="">
                            <Link
                                to="/change-password"
                                className="px-4 py-2 flex items-center gap-2 text-[14px]   hover:bg-[#F5F5F5] whitespace-nowrap cursor-pointer"
                            >
                                <IoKeyOutline size={"1.6em"} className="" /> <span className="pl-1">Change Password</span>
                            </Link>
                            <button
                                type="button"
                                onClick={handleLogout}
                                className="w-full px-4 py-2 flex items-center gap-2 text-[14px] hover:bg-[#F5F5F5] whitespace-nowrap cursor-pointer group"
                            >
                                <LuLogOut size={"1.6em"} className="group-hover:text-[#87213C]" /> <span className="pl-1">Logout</span>
                            </button>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default Top;
